import React from "react";
import settingable from "fantastic/components/hoc/settingable";

const OrganizationSettings = props => {
  return null;
};

export default settingable("background", "padding", "visibility")(OrganizationSettings);
